import React from 'react'
import './lyoload.css'

export default function LyoLoad() {
  return (
    <div className='LyoLoad'>
        <div className="lyo-load" id='i1'></div>
        <div className="lyo-load" id='i2'></div>
        <div className="lyo-load" id='i3'></div>
        <div className="lyo-load" id='i4'></div>
        <div className="lyo-load" id='i5'></div>
        <div className="lyo-load" id='i6'></div>
        <div className="lyo-load" id='i7'></div>
    </div>
  )
}
